export const name = 'maximumLength';
/**
 * Determines if value length exceeds max value passed in
 *
 * @param value Value to make determination against
 * @param max Integer value to check against value
 */
const maximumLength = async (value, max) => (value.trim().length <= max);
maximumLength.defaultMessage = 'Field is too long.';
export { maximumLength };
